import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ERROR, StateMensageCallBack, StateMensage as StateMessage, StateType } from '../types/base/base';
import ValidationResult from 'domain/types/global/validationResult'
import { AppThunk } from 'base/src/utils/reducerUtil';

function IsAllNull<T>(obj: T): boolean {
  //@ts-expect-error: Divergencia de tipos, mas funciona
  return Object.values(obj).every(value => value === null);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function SetObject<T>(key: string, value: any, state: T, setState: React.Dispatch<React.SetStateAction<T>>) {
  if (typeof state === 'object') {
    const r = { ...state };
    //@ts-expect-error: Divergencia de tipos, mas funciona
    r[key] = value
    setState(r);
  } else {
    setState(value)
  }
}

export class ObjectControl<T> {
  public state: T;
  public setState: React.Dispatch<React.SetStateAction<T>>;
  public initialState?: T | undefined;

  public resetMode: boolean;

  constructor(state: T, setState: React.Dispatch<React.SetStateAction<T>>, initialState: T | undefined = undefined) {
    this.state = state;
    this.setState = setState;
    this.initialState = initialState;
    this.resetMode = false;
  }

  setObject(key: string, value: any) {
    if (this.resetMode == true) {
      const res = IsAllNull(this.state);
      if (this.state == this.initialState || res) {
        this.resetMode = false;
      } else { return }
    }
    SetObject(key, value, this.state, this.setState)
  }

  reset() {
    this.resetMode = true
    if (this.initialState != undefined) {
      this.setState(this.initialState)
    } else {
      const r = { ...this.state };
      for (const key in this.state) {
        if (typeof this.state === 'object') {
          //@ts-expect-error: Divergencia de tipos, mas funciona
          r[key] = null
        }
      }
      this.setState(r);
    }
  }
}


export function ValueCheckKey<T, K extends keyof T>(array: Array<T>, value: T[K], key: K): boolean {
  if (array == null || array.length == 0) {
    return false;
  }

  // Verifica se existe algum item no array que tenha a propriedade `key` igual ao `value`
  const x = array.some(item => item[key] === value);

  return x;
}

export function ValueCheck<T>(array: Array<T> | undefined, value: T, key?: keyof T | undefined): boolean {
  if (array == null || array.length == 0) {
    return false;
  }

  let x: boolean

  if (key == undefined) {
    x = array.includes(value)
  } else {
    x = array.some(item => item[key] === value[key]);
  }

  return x;
}


export function SetArrayObject<T>(array: T[] | undefined, value: T, state: boolean): T[] {
  const arrayTemp = array == null ? [] : [...array];

  if (state) {
    if (!arrayTemp.includes(value)) {
      arrayTemp.push(value)
    }
  } else {
    if (arrayTemp.includes(value)) {
      arrayTemp.splice(arrayTemp.indexOf(value), 1)
    }
  }

  return arrayTemp;
}

export function IsArrayOfType<T>(value: unknown): value is T[] {
  return Array.isArray(value);
}

export function DispatchLoading(
  dispatchName: string,
  state: DispatchType,
  message?: string,
  loadingType: StateType = StateType.Local,
  callback?: StateMensageCallBack | (()=>void)
): AppThunk {
  return async (dispatch) => {
    const loading: StateMessage = {
      Name: state,
      Type: loadingType,
      Message: message,
      //@ts-expect-error: Divergencias, mas funciona
      CallBack: callback
    };

    dispatch({ payload: loading, type: `${dispatchName}_${state}` });
  };
}

/* eslint-disable no-unused-vars */
export function isValidObject<T>(obj: any): obj is T {
  // Verificar tipos básicos ou arrays
  if (
    typeof obj === "string" ||
    Array.isArray(obj) ||
    (typeof obj === "object" && obj !== null)
  ) {
    return true;
  }
  return false;
}


export function isValidationResult(obj: any): obj is ValidationResult {
  return obj && typeof obj === "object" && "IsValid" in obj && "Message" in obj;
}

export function ResponseValid<T>(response: T, allowNull: boolean = true, dispatchForError: ThunkDispatch<any, any, Action> | undefined = undefined): boolean {
  function GenerateError(msg: string) {
    if (dispatchForError != null) {
      dispatchForError(DispatchLoading(ERROR, DispatchType.ERROR,
        msg,
        StateType.Local))
    }
  }

  // Verificar se allowNull é falso e response é nulo ou vazio
  if (!allowNull && (!response || response == null || response === "")) {
    return false;
  }

  //ValidationResult
  if (isValidationResult(response)) {
    const validationResult = response as ValidationResult;
    if (!validationResult.IsValid) {
      GenerateError(validationResult.Message);
      return false;
    }
    return true;
  }
  //Error
  if (response instanceof Error) {
    GenerateError(response ? (response as Error).message : "Error")
    return false;
  }

  //`T`
  if (isValidObject<T>(response)) {
    return true;
  }
  // Caso não atenda a nenhum dos critérios
  return false;

}

export enum DispatchType {
  LOADING = "LOADING",
  SUCCESS = "SUCCESS",
  PARTIAL = "PARTIAL",
  ERROR = "ERROR",
  TOAST = "TOAST"
}


export function GenerateUniqueId(array: { Id: number }[]): number {
  if (array == null || array.length == 0) { return 0 }
  const existingIds = array.map(item => item.Id);
  let newId = 1;

  while (existingIds.includes(newId)) {
    newId++;
  }

  return newId;
}